//--------------- IMPORTAÇÕES ---------------//
import { useEffect, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Loading } from "../../shared/components";
import { Main } from "./components";
import { loadGroupsService, loadProductsService } from "./services";
import { GruposContext } from "./context/GruposContext";
import { LoadingContext } from "../../shared/context/LoadingContext";



//--------------- EXPORTAÇÃO DA PÁGINA GRUPOS ---------------//
export default function Grupos() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { groups, setGroups } = useContext(GruposContext); // Contexto que armazena a lista de Grupos existentes
    const { products, setProducts } = useContext(GruposContext); // Contexto que armazena a lista de Produtos existentes
    const { isLoading, setIsLoading } = useContext(LoadingContext); // Contexto que armazena se a tela de carregamento está aparecendo ou não



    //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
    useEffect(() => {
        setIsLoading(true);
        handleLoadGroups();
        handleLoadProducts();
        setIsLoading(false);
    }, []);



    //--------------- FUNÇÃO ASSÍNCRONA CARREGAR GRUPOS ---------------//
    // Responsável por requisitar à API os Grupos existentes
    // Armazena no Estado "grupos" a lista de Grupos retornada pela API
    async function handleLoadGroups() {
        const response = await loadGroupsService();
        if (response) {
            setGroups(response.data);
        }
    }



    //--------------- FUNÇÃO ASSÍNCRONA CARREGAR GRUPOS ---------------//
    // Responsável por requisitar à API os Produtos existentes
    // Armazena no Estado "produtos" a lista de Produtos retornada pela API
    async function handleLoadProducts() {
        const response = await loadProductsService();
        if (response) {
            setProducts(response.data);
        }
    }



    //--------------- RETORNO CONDICIONAL DA PÁGINA GRUPOS ---------------//
    return (
        <>
            {isLoading ? <Loading /> : <Main />}
        </>
    )
}